import React, { useState } from 'react';
import moment from 'moment';
import { MenuPopup } from '@prosolve/common-components-ui'
import { 
  FaBed, 
  FaHotel, 
  FaMapMarkerAlt, 
  FaRegCheckCircle, 
  FaUsers,
  FaEllipsisH
} from "react-icons/fa";
import { checkHasEditEventPermissions, checkHasEventTrainerPermissions } from '../../../../../utils';
import useIsMobileView from "../../../../../hooks/useIsMobileView";

const LabelValue = ({ label = '', value = '', labelIcon, wrapperStyle = {}, labelStyle = {}, valueStyle = {}}) => {
  const labelEl = <div style={{ color: '#565656', marginBottom: '5px', ...labelStyle }}>{label}</div>;
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      rowGap: '3px',
      ...wrapperStyle
    }}>
      {
        labelIcon ?
        <div style={{ 
          display: 'flex', 
          // alignItems: 'center' 
        }}>
          <div style={{ marginRight: '10px'}}>
            {labelIcon}
          </div>
          {labelEl}
        </div>
        :
        labelEl
      }
      <div style={{ ...valueStyle }}>{value}</div>
    </div>
  )
}

export default ({ 
  hotelData = {},
  onEditHotel,
  onDeleteHotel,
}) => {
  const isMobileView = useIsMobileView();
  
  const hasEditPermissions = ( checkHasEditEventPermissions() || checkHasEventTrainerPermissions() );

  const labelWidth = '150px';

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const onMenuSelection = (val) => {
    if (val === 'Edit') {
      onEditHotel(hotelData)
    } else if (val === 'Delete') {
      onDeleteHotel(hotelData)
    }
  }

  return (
    <div style={{ 
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      border: '1px solid #c4c4c4',
      borderRadius: '10px',
      maxWidth: isMobileView ? 'none' : 'calc(50% - 51px)',
      flexBasis: isMobileView ? 'auto' : 'calc(50% - 52px)'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: isMobileView ? 'column': 'row',
        rowGap: '10px',
        position: 'relative',
        // justifyContent: 'space-between',
        marginBottom: '20px',
        paddingBottom: '10px',
        borderBottom: '1px solid #c4c4c4',
      }}>
        {
          !isMobileView &&
          <FaBed style={{ color: '#565656', marginRight: '20px', fontSize: '20px' }} />
        }
        <LabelValue 
          wrapperStyle={{ marginRight: '40px' }} 
          label='Check In' 
          value={hotelData.checkIn ? moment(hotelData.checkIn).format('ddd, MMMM DD, YYYY') : ''} 
        />
        <LabelValue 
          wrapperStyle={{ marginRight: '40px' }} 
          label='Check Out' 
          value={hotelData.checkOut ? moment(hotelData.checkOut).format('ddd, MMMM DD, YYYY') : ''} 
        />
        {
          hasEditPermissions &&
          <div style={{ position: 'absolute', top: '0px', right: '0px' }}>
            <FaEllipsisH
              style={{ color: '#7e7e7e', padding: '10px', cursor: 'pointer' }}
              onClick={(e) => { e.stopPropagation(); setIsMenuOpen(true) }}
            />
            <MenuPopup
              open={isMenuOpen}
              top='30px'
              left='-50px'
              options={['Edit', 'Delete']}
              onClose={() => setIsMenuOpen(false)}
              onSelection={(val) => onMenuSelection(val)}
            />
          </div>
        }
      </div>
      <div style={{ 
        display: 'flex',
        flexDirection: 'column',
      }}>
        <LabelValue 
          wrapperStyle={{ flexDirection: isMobileView ? 'column': 'row', marginBottom: '15px' }} 
          labelStyle={{ width: labelWidth }} 
          labelIcon={<FaHotel style={{ color: '#565656' }} />} 
          label='Hotel Name' 
          value={hotelData.hotelName} 
        />
        <LabelValue 
          wrapperStyle={{ flexDirection: isMobileView ? 'column': 'row', marginBottom: '15px' }} 
          labelStyle={{ width: labelWidth }} 
          labelIcon={<FaMapMarkerAlt style={{ color: '#565656' }} />} 
          label='Address' 
          value={
            <a
              style={{ color: '#0280c6' }}
              href={`https://maps.google.com/?q=${hotelData && hotelData.address}`}
              target="_blank"
              rel="noreferrer"
            >
              {hotelData.address}
            </a>
          } 
        />
        <LabelValue 
          wrapperStyle={{ flexDirection: isMobileView ? 'column': 'row', marginBottom: '15px' }} 
          labelStyle={{ width: labelWidth }} 
          labelIcon={<FaRegCheckCircle style={{ color: '#565656' }} />} 
          label='Confirmation' 
          value={hotelData.hotelConfirmation} 
        />
        <LabelValue 
          wrapperStyle={{ flexDirection: isMobileView ? 'column': 'row' }} 
          labelStyle={{ width: labelWidth }} 
          labelIcon={<FaUsers style={{ color: '#565656' }} />} 
          label='Name(s)' 
          value={hotelData.personStaying} 
        />
      </div>
    </div>
  );
};
